import { t } from 'i18next';
import { Button, Icon, PermissionProtected } from '@stigg-components';
import { EnvironmentPermissionActions } from '@stigg-permissions';

type ProvisionWithAIButtonProps = {
  onClick: () => void;
};

export function ProvisionWithAIButton({ onClick }: ProvisionWithAIButtonProps) {
  return (
    <PermissionProtected permission={EnvironmentPermissionActions.SubscriptionWrite}>
      <Button
        data-testid="button-provision-using-ai"
        color="primary"
        $outlined
        onClick={onClick}
        startIcon={<Icon icon="StiggAI" color="primary.main" overrideStroke />}>
        {t('ai.provisionSubscriptionWithAI.provisionButton')}
      </Button>
    </PermissionProtected>
  );
}
